export function cleanContentFromCustomFields(content: string): string {
  return content.replace(/\$\{\d+#([^}]*)\}/g, '$1');
}
